import { GetLoginToken, RefreshToken, GetJsSignPack, InNewsRecord, inH5Record, getBuyerNick } from '@/api/Public';
import QUERY from '@/api_app/Public'
import router from "@/router";
import { Toast } from 'vant';

const state = {
  show_loading: false,
  token: null,
  CustomerInfo: {},
  UserInfo: {},
  popupType: false,
  //
  visitor_id: '',
  getSappMenuInfo: {},
  TabbarMap: [
    { Name: '客户消息', Off: 'customer_message_khxx1.png', On: 'customer_message_khxx2.png', path: 'CustomerMessage' },
    { Name: '通讯录', Off: 'customer_message_txl1.png', On: 'customer_message_txl2.png', path: 'AddressBook' },
    { Name: '昨日简报', Off: '', On: '', path: 'YesterdayBriefing_APP' },
    { Name: '客户预警', Off: 'customer_message_khyj1.png', On: 'customer_message_khyj2.png', path: 'CustomerWarn' },
    { Name: '设置', Off: 'customer_message_sz1.png', On: 'customer_message_sz2.png', path: 'set' },
  ],
  TabbarActive: {
    Active: 0
  },
  AccountInfo: {}, //判断显示哪个缺省页
  ManualHelp: {
    contactDivShow: true,
    contactImg: false,
  },
  scrollValue: 0,
};

const mutations = {
  SET_DATA: (state, { key, data }) => {
    state[key] = data;
  },
  SHOW_LOADING: (state, { data }) => {
    state['show_loading'] = data;
  },
  UserInfo: (state, { data }) => {
    state['UserInfo'] = data;
  },
  // APP
  SwitchTabbarActive: (state, data) => {
    state['TabbarActive'] = { Active: parseInt(data) };
  },
  AccountInfo: (state, { data }) => {
    state['AccountInfo'] = data;
  },
  ManualHelp: (state, { data }) => {
    state['ManualHelp'] = data;
  },
};
const actions = {
  GetLoginToken({ commit }, data) { // 获取token
    return new Promise((resolve) => {
      GetLoginToken(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          if (res.data.code == 1000) {
            sessionStorage.setItem('x-token', res.data.data)
            commit("SET_DATA", { key: 'token', data: res.data.data });
            alert(res.data.data + '--x-token')
          }
        } catch (error) {
          console.log(error)
        }
        resolve(res.data)
      });

    })
  },
  RefreshToken({ commit }, data) { // 刷新token
    return new Promise((resolve) => {
      RefreshToken(data).then(res => {
        resolve(res.data)
      });
    })
  },
  GetJsSignPack({ commit }, data) { // 获取微信jssdk配置参数
    return new Promise((resolve) => {
      GetJsSignPack(data).then(res => {
        resolve(res.data)
      });
    })
  },
  InNewsRecord({ commit }, data) { // 图文消息访问记录
    return new Promise((resolve) => {
      InNewsRecord(data).then(res => {
        resolve(res.data)
      });
    })
  },
  getBuyerNick({ commit }, data) { // 获取旺旺名称接口
    return new Promise((resolve) => {
      getBuyerNick(data).then(res => {
        resolve(res.data)
      });
    })
  },
  // APP
  // 获取通讯录的标签
  getSappMenuInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getSappMenuInfo', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'getSappMenuInfo', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 缺省页判断接口
  getAccountInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getAccountInfo', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'getAccountInfo', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // '立即续费'弹窗判断
  renew({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'renew', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'renew', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 埋点接口
  inH5Record({ commit }, params) {

    if (params.vid && params.vid !== '') {
      params = {
        page_name: params.page_name || router.history.current.name,
        page_from: params.page_from || 'main_page',
        page_time: params.page_time || '0.00',
        btn_name: params.btn_name || '',
        page_param: params.page_param || {},
        vid: params.vid
      }
      params.page_param.source = localStorage.getItem('source')
    } else {
      params = {
        page_name: params.page_name || router.history.current.name,
        page_from: params.page_from || 'main_page',
        page_time: params.page_time || '0.00',
        btn_name: params.btn_name || '',
        page_param: params.page_param || {},
      }
      params.page_param.source = localStorage.getItem('source')
    }

    return new Promise((resolve, reject) => {
      QUERY({ key: 'inH5Record', params }).then(response => {
        const { data } = response
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取旺旺昵称接口
  getBuyerNick_APP({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key: 'getBuyerNick', params }).then(response => {
        const { data } = response
        if (data.code != 1000) {
          Toast(data.message)
        } else {
          commit('SET_DATA', { key: 'getKfList', data: data.data })
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
